module.exports = {"513324100":"呷尔镇","513324101":"烟袋镇","513324200":"汤古乡","513324201":"斜卡乡","513324202":"三岩龙乡","513324203":"上团乡","513324204":"八窝龙乡","513324205":"乃渠乡","513324206":"乌拉溪乡","513324208":"魁多乡","513324209":"子耳彝族乡","513324210":"三垭彝族乡","513324211":"俄尔彝族乡","513324212":"小金彝族乡","513324213":"朵洛彝族乡","513324214":"踏卡彝族乡","513324215":"湾坝彝族乡","513324216":"洪坝乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513324.json
// module id = 2229
// module chunks = 0